import React, {useRef} from 'react';
import {Field, FieldArray, Formik} from "formik";
import {makeStyles} from "@material-ui/styles";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "../../Ui/TextField";
import * as Yup from 'yup'
import {Divider} from "@material-ui/core";
import useFicheTypeData from "../../../hooks/DataProvider/useFicheTypeData";
import useLocationData from "../../../hooks/DataProvider/useLocationData";
import GoogleMapsComponent from "../../Ui/GoogleMapsComponent";
import GoogleMapsInput from "../../FormFields/Fiche/GoogleMapsInput";
import useCauseData from "../../../hooks/DataProvider/useCauseData";
import FileInput from "../../Ui/FileInput";
import BootstrapLoadingButton from "../../Ui/BootstrapLoadingButton";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import SVG from "react-inlinesvg";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import NewFicheFormStepIcon from "../../Modules/Fiches/NewFicheFormStepIcon";
import Button from "@material-ui/core/Button";
import {generateRandomString, getItemById} from "../../../utils/helpers";
// import {TextField} from "formik-material-ui";
import {toast} from "react-toastify";

import {Link, useLocation, useHistory} from 'react-router-dom';
import axios from "axios";
import {
    FIND_FICHE_BY_CODE,
    FIND_FICHE_BY_FORM_CODE, STEP_SAVE_CONTACT,
    STEP_SAVE_DESCRIPTION,
    STEP_SAVE_LOCALISATION, STEP_SAVE_PERIOD
} from "../../../api/Api";
import useDonneeTechniqueData from "../../../hooks/DataProvider/useDonneeTechniqueData";
import Checkbox from "@material-ui/core/Checkbox";
import ConfirmationModal from "../../Modals/ConfirmationModal";
import moment from 'moment';
import InputAdornment from "@material-ui/core/InputAdornment";
import FormikGeoAutocomplete from "../../Ui/FormikGeoAutocomplete";

const useStyles = makeStyles(
    (theme) => {
        return {
            marginSpace: {
                margin: theme.spacing(0, 1)
            },
            dividerMargin: {
                marginBottom: theme.spacing(4)
            },
            stepperRoot: {
                '& .MuiStep-root': {
                    display: 'flex',
                    alignItems: 'center',
                    '&.active': {
                        color: theme.palette.primary.main
                    },
                    '& .MuiStepLabel-label.MuiStepLabel-active': {
                        color: theme.palette.primary.main,
                    },
                    '& .MuiStepLabel-label.MuiStepLabel-completed': {
                        color: theme.palette.primary.main,
                    }
                },
                '&.active': {
                    '& .connector': {
                        color: theme.palette.primary.main
                    }
                }
            }
        }
    }
);

const today = moment();


const initialValues = {
    'code': '',
    'adresse_geo_chantier': '',
    'lat_lng': [],

    'date_debut_travaux': '',
    'date_fin_travaux': '',
    'informations_supplementaire_periode': '',
    'planning_travaux': [],
    'informations_supplementaire': '',

    'type_client_id': '',
    'nom': '',
    'prenoms': '',
    'raison_sociale': '',
    'mobile': '',
    'email': '',
    'email_confirmation': '',
    'siege_sociale': '',
    'nom_enterprise': '',
    'nom_sous_traitant': '',
    'nom_prenoms_responsable_chantier': '',
    'fonction_responsable_chantier': '',
    'contact_responsable_chantier': '',

    'type_travaux': '',
    'nature_travaux': [],
    'description_travaux': '',
    'technique_travaux': [],
    'technique_terrassement_type': [],
    'hauteurs': {},
    'moyen_utilise_travaux': [],
    'moyen_utilise_travaux_autre': '',
    'plan_implentation_travaux': [],

    'autre_cie': '',
    'autre_sodecie': '',

    'adresse_equipement_cie_proche': '',
    'adresse_equipement_sodeci_proche': '',
    'zone_travaux_file': '',
    'ville_id': [],
    'quartier_id': [],
    'commune_id': [],
    'rue_id': [],
    'rue': '',
    'description_localisation': '',
    'fichiers_numerique_ouvrage': [],

    implantation_travaux_files_link: '',
    ouvrages_numeriques_files_link: '',
    zone_travaux_file_link: '',
    planning_travaux_file_link: ''

};

function deleteNullValue(map) {
    return Object.entries(map).map(
        ([key, value]) => {
            if (value == null) {
                return [key, '']
            }
            return [key, value];
        }
    ).reduce(
        (accumulator, [key, value]) => {
            return {
                ...accumulator,
                [key]: value
            }
        }, {}
    );
}

const descriptionSchema = Yup.object().shape({
    'type_travaux': Yup.string().required('Champ obligatoire'),
    'nature_travaux': Yup.array().min(1, 'Champ obligatoire').required('Champ obligatoire'),
    'description_travaux': Yup.string().required('Champ obligatoire'),
    'technique_travaux': Yup.array().when(
        'type_travaux',
        {
            is: function (value) {
                return value == 1 || value == 3
            },
            then: Yup.array().required('Champ obligatoire')
        }
    ),
    'technique_terrassement_type': Yup.array()
        .when(
            'technique_travaux',
            {
                is: 'Terrassement',
                then: Yup.array().required('Champ obligatoire')
            }
        )
    ,
    plan_implentation_travaux: Yup.array().test(
        {
            test: function (value) {

                const {implantation_travaux_files_link} = this.parent;

                return !!implantation_travaux_files_link || (value.length > 0 && value.filter(item => !item.value).length == 0);
            },
            message: 'Champ obligatoire'
        }
    ),
    implantation_travaux_files_link: Yup.string().test(
        {
            test: function (value) {

                const {plan_implentation_travaux} = this.parent;

                return (plan_implentation_travaux.length > 0 && plan_implentation_travaux.filter(item => !item.value).length == 0) || !!value;
            },
            message: 'Champ obligatoire'
        })
    ,
    'moyen_utilise_travaux': Yup.array().when(
        'type_travaux',
        {
            is: function (value) {
                return value == 1 || value == 3
            },
            then: Yup.array().min(1, 'Vous devez sélectionner au moins un élément').required('Champ obligatoire')
        }
    ),
    'moyen_utilise_travaux_autre': Yup.string().nullable().when(
        'moyen_utilise_travaux',
        {
            is: (values) => {
                return !!values.includes(-1)
            },
            then: Yup.string().required('Champ obligatoire')
        }
    ),
});

const contactSchema = Yup.object().shape({
    'type_client_id': Yup.number().required('Champ obligatoire'),
    nom: Yup.string().nullable(true).when('type_client_id', {
        is: 1,
        then: Yup.string().nullable(false).required('Champ obligatoire')
    }),
    prenoms: Yup.string().nullable(true).when('type_client_id', {
        is: 1,
        then: Yup.string().nullable(false).required('Champ obligatoire')
    }),
    raison_sociale: Yup.string().nullable(true).when('type_client_id', {
        is: value => !![2, 3].includes(value),
        then: Yup.string().nullable(false).required('Champ obligatoire')
    }),
    'mobile': Yup.string().nullable(true).required('Champ obligatoire').matches(
        /^[0-9]{10}$/, 'Vous devez saisir un numéro de téléphone valide'
    ),
    'mobile_2': Yup.string().nullable(true).nullable(true).matches(
        /^[0-9]{10}$/, 'Vous devez saisir un numéro de téléphone valide'
    ),
    'email': Yup.string().email('Vous devez saisir une adresse email valide').required('Champ obligatoire'),
    'email_confirmation': Yup.string().required('Champ obligatoire').oneOf([Yup.ref('email'), null], 'L\'adresse email doit être identique'),
    'nom_enterprise': Yup.string().required('Champ obligatoire'),
    // 'nom_sous_traitant': Yup.string().required('Champ obligatoire'),
    'contact_responsable_chantier': Yup.string().nullable(true).matches(
        /^[0-9]{10}$/, 'Vous devez saisir un numéro de téléphone valide'
    ),
});

const locationSchema = Yup.object().shape({
    'description_localisation': Yup.string().required('Champ obligatoire'),
    'ville_id': Yup.array().min(1, 'Champ obligatoire').required('Champ obligatoire'),
    fichiers_numerique_ouvrage: Yup.array().test(
        {
            test: function (value) {

                const {ouvrages_numeriques_files_link} = this.parent;

                return !!ouvrages_numeriques_files_link || (value.length > 0 && value.filter(item => !item.value).length == 0);
            },
            message: 'Champ obligatoire'
        }
    ),
    ouvrages_numeriques_files_link: Yup.string().test(
        {
            test: function (value) {

                const {fichiers_numerique_ouvrage} = this.parent;

                return (fichiers_numerique_ouvrage.length > 0 && fichiers_numerique_ouvrage.filter(item => !item.value).length == 0) || !!value;
            },
            message: 'Champ obligatoire'
        })


});

const periodeSchema = Yup.object().shape({
    'date_debut_travaux': Yup.date().required('Champ obligatoire').min(today.format('YYYY-MM-DD'), `Vous ne pouvez pas sélectionner une date antérieure au ${today.format('DD/MM/YYYY')}`),
    'date_fin_travaux': Yup.date().required('Champ obligatoire').min(Yup.ref('date_debut_travaux'), 'La date de fin des travaux ne peut pas être antérieure à la date de début'),
    // planning_travaux: Yup.array().test(
    //     {
    //         test: function(value){
    //
    //             const {planning_travaux_file_link} = this.parent;
    //
    //             return !!planning_travaux_file_link || (value.length > 0 && value.filter(item=>!item.value).length == 0);
    //         },
    //         message: 'Champ obligatoire'
    //     }
    // ),
    // planning_travaux_file_link: Yup.string().test(
    //     {
    //         test: function(value){
    //
    //             const {planning_travaux} = this.parent;
    //
    //             return (planning_travaux.length > 0 && planning_travaux.filter(item=>!item.value).length == 0) || !!value ;
    //         },
    //         message: 'Champ obligatoire'
    //     })

});


const validations = [descriptionSchema, locationSchema, periodeSchema, contactSchema];


const NewFicheForm = React.forwardRef(
    (props, formikRef) => {

        const history = useHistory();
        const {isSearching, onFormSubmit, isSubmitting, onUpdate} = props;
        const innerRef = useRef(null);

        const [isLoadingNatures, natures] = useDonneeTechniqueData('nature_travaux');
        const [isLoadingTechniquesTravaux, techniquesTravaux] = useDonneeTechniqueData('technique_travaux');
        const [isLoadingMoyensUtilise, moyensUtilise] = useDonneeTechniqueData('moyens_utilise');

        const groupedNature = React.useMemo(
            () => {
                return {
                    1: natures.filter(nature => nature.societe === 'cie'),
                    2: natures.filter(nature => nature.societe === 'sodeci'),
                    3: natures
                }
            }, [natures]
        );

        const classes = useStyles();

        const queries = new URLSearchParams(useLocation().search);

        let initialStep = queries.get('step');
        const queryFormCode = queries.get('formCode');

        if (!['0', '1', '2', '3'].includes(initialStep))
            initialStep = 0;

        else
            initialStep = parseInt((initialStep))

        React.useEffect(() => {

            if (queryFormCode) {

                loadDetails()

            }

        }, [])

        const [isLoadingFicheTypes, ficheTypes] = useFicheTypeData()

        const [savedDatas, setSavedDatas] = React.useState();
        const [isLoadingDetails, setIsLoadingDetails] = React.useState(false);


        const [selectedVilles, setSelectedVilles] = React.useState([]);
        const [selectedCommunes, setSelectedCommunes] = React.useState([]);
        const [selectedQuartiers, setSelectedQuartier] = React.useState([]);
        const [currentStep, setCurrentStep] = React.useState(initialStep);

        const [isStepSaving, setIsStepSaving] = React.useState(false);


        const formCode = React.useMemo(
            () => {
                return generateRandomString(15)
            }
        );

        const currentSchema = React.useMemo(
            () => {
                return validations[currentStep];
            }, [currentStep]
        )


        const childCommunes = React.useMemo(
            () => {

                return selectedVilles.reduce(
                    (accumulator, ville) => {
                        return [
                            ...accumulator,
                            ...(ville?.communes || [])
                        ]
                    }, []
                )
            }, [selectedVilles]
        );

        const childQuartiers = React.useMemo(
            () => {
                return selectedCommunes.reduce(
                    (accumulator, commune) => {
                        return [
                            ...accumulator,
                            ...(commune?.quartiers || [])
                        ]
                    }, []
                )
            }, [selectedCommunes, childCommunes]
        );

        const childRues = React.useMemo(
            () => {

                return selectedQuartiers.reduce(
                    (accumulator, quartier) => {

                        const quartierData = childQuartiers.find(
                            item => {
                                return item.id == quartier
                            }
                        );

                        return [
                            ...accumulator,
                            ...(quartierData?.rues || [])
                        ]
                    }, []
                )

            }, [selectedQuartiers, childQuartiers]
        );

        const formInitialState = React.useMemo(
            () => {

                if (savedDatas) {
                    return savedDatas;
                }

                if (!queryFormCode)
                    return initialValues;

                else if (savedDatas) {
                    return savedDatas;
                }

            }, [savedDatas]
        );


        const filters = React.useMemo(() => {

            const map = {};

            if (selectedVilles)
                map.villes = selectedVilles.map(item => item.id)

            if (selectedCommunes)
                map.communes = selectedCommunes.map(item => item.id)

            return map;
        }, [selectedVilles, selectedCommunes]);


        async function loadDetails() {

            try {

                setIsLoadingDetails(true);

                const response = await axios.get(
                    `${FIND_FICHE_BY_FORM_CODE}`,
                    {
                        params: {
                            code: queryFormCode
                        }
                    }
                );

                const ville_id = response.data.villes.map(item => ({
                    ...item,
                    value: item
                }));
                const commune_id = response.data.communes.map(item => ({
                    ...item,
                    value: item
                }));
                const quartier_id = response.data.quartiers.map(item => ({
                    ...item,
                    value: item
                }));
                // const rue_id = response.data.rues;

                setSavedDatas(
                    deleteNullValue({
                        ...response.data,
                        technique_travaux: response.data.technique_travaux_data.map(item => item.libelle),
                        ville_id,
                        commune_id,
                        quartier_id,
                        // rue_id,
                        lat_lng: response.data.lat_lng || [],
                        email_confirmation: response.data.email
                    })
                );

                setSelectedVilles(ville_id)
                setSelectedCommunes(commune_id)
                setSelectedQuartier(quartier_id)

            } catch (e) {

                if (e.response && e.response.status === 404)
                    toast.error('Aucune demande trouvé avec ce code', {
                        position: "bottom-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });

            } finally {
                setIsLoadingDetails(false);
            }

        }

        async function stepSaving(url, values) {

            try {

                setIsStepSaving(true);


                const response = await axios.post(
                    url,
                    {
                        ...values,
                        form_code: queryFormCode || formCode,
                        technique_travaux: values.technique_travaux.map(
                            item => {
                                return techniquesTravaux.find(tech => tech.libelle == item)?.id
                            }
                        ),
                        geo_lat: values.lat_lng?.lat,
                        geo_lng: values.lat_lng?.lng,
                    });


                const ville_id = response.data.villes;
                const commune_id = response.data.communes;
                const quartier_id = response.data.quartiers;
                // const rue_id = response.data.rues.map(item => item.id);

                setSavedDatas(
                    deleteNullValue({
                        ...response.data,
                        ville_id,
                        technique_travaux: response.data.technique_travaux_data.map(item => item.libelle),
                        commune_id,
                        quartier_id,
                        // rue_id,
                        lat_lng: response.data.lat_lng || [],
                        email_confirmation: response.data.email
                    })
                );

                setSelectedVilles(ville_id)
                setSelectedCommunes(commune_id)
                setSelectedQuartier(quartier_id)

            } catch (e) {

                console.log(e)
                throw e;

            } finally {

                setIsStepSaving(false)

            }


        }

        async function saveDescription() {

            if (!savedDatas)
                await stepSaving(STEP_SAVE_DESCRIPTION, {
                    ...innerRef.current.values,
                })

            else
                await stepSaving(`${STEP_SAVE_DESCRIPTION}/${savedDatas.id}`,
                    {
                        ...innerRef.current.values,
                    })

            if (currentStep < 3)
                setCurrentStep(currentStep + 1);

        }

        async function saveLocalisation() {

            await stepSaving(`${STEP_SAVE_LOCALISATION}/${savedDatas.id}`, {
                ...innerRef.current.values,
                ville_id: innerRef.current.values.ville_id.map(item => item.id),
                commune_id: innerRef.current.values.commune_id.map(item => item.id),
                quartier_id: innerRef.current.values.quartier_id.map(item => item.id),

            })

            if (currentStep < 3)
                setCurrentStep(currentStep + 1);

        }

        async function savePeriode() {

            await stepSaving(`${STEP_SAVE_PERIOD}/${savedDatas.id}`, innerRef.current.values)

            if (currentStep < 3)
                setCurrentStep(currentStep + 1);

        }

        async function saveContact() {

            try {

                await stepSaving(`${STEP_SAVE_CONTACT}/${savedDatas.id}`, innerRef.current.values)

                history.push(`/fiches/recapitulatif/${savedDatas.code}`);

            } catch (e) {

            }

        }

        async function goToRecapitulatif() {

            const validationResult = await innerRef.current.validateForm(innerRef.current.values);

            const touchedFields = Object.keys(validationResult).reduce(
                (accumulator, current) => {

                    accumulator[current] = true

                    return accumulator;
                }, {}
            )

            innerRef.current.setTouched(touchedFields);

            innerRef.current.setErrors(validationResult)
            console.log('formik validation result', validationResult);

            if (Object.keys(validationResult).length == 0) {

                if (currentStep == 0)
                    await saveDescription();

                else if (currentStep == 1)
                    await saveLocalisation();

                else if (currentStep == 2)
                    await savePeriode();

                else if (currentStep == 3)
                    await saveContact();

            }

            history.push(`/fiches/recapitulatif/${savedDatas.code}`);

        }

        async function goToNextStep() {

            const validationResult = await innerRef.current.validateForm(innerRef.current.values);

            const touchedFields = Object.keys(validationResult).reduce(
                (accumulator, current) => {

                    accumulator[current] = true

                    return accumulator;
                }, {}
            )

            innerRef.current.setTouched(touchedFields);

            innerRef.current.setErrors(validationResult)
            console.log('formik validation result', validationResult);

            if (Object.keys(validationResult).length == 0) {

                if (currentStep == 0)
                    saveDescription();

                else if (currentStep == 1)
                    saveLocalisation();

                else if (currentStep == 2)
                    savePeriode();

                else if (currentStep == 3)
                    saveContact();

            }

        }

        function goToPrevStep() {
            setCurrentStep(currentStep - 1)
        }

        async function finishProcess() {

            const validationResult = await innerRef.current.validateForm(innerRef.current.values);

            const touchedFields = Object.keys(validationResult).reduce(
                (accumulator, current) => {

                    accumulator[current] = true

                    return accumulator;
                }, {}
            )

            innerRef.current.setTouched(touchedFields);

            innerRef.current.setErrors(validationResult)

            if (Object.keys(validationResult).length == 0) {

            }

        }

        function saveAndSendValidationMail() {


        }

        return (
            <>


                {
                    (!queryFormCode ||
                        queryFormCode && savedDatas
                    ) && (

                        <Formik
                            innerRef={innerRef}
                            handleChange={() => {

                            }}
                            validationSchema={currentSchema}
                            initialValues={formInitialState}
                            enableReinitialize={true}
                            onSubmit={(values, helpers) => {

                                helpers.setSubmitting(false);

                                if (!savedDatas && onFormSubmit)
                                    onFormSubmit({
                                        ...values,
                                        technique_travaux: values.technique_travaux.map(
                                            item => {
                                                return techniquesTravaux.find(tech => tech.libelle == item)?.id
                                            }
                                        ),
                                        ville_id: values.ville_id.map(item => item.id),
                                        commune_id: values.commune_id.map(item => item.id),
                                        quartier_id: values.quartier_id.map(item => item.id),
                                    })

                                else if (savedDatas && onUpdate)
                                    onUpdate(savedDatas, values)


                            }}
                        >

                            {
                                (formikHelpers) => {


                                    // console.log(formikHelpers.errors);

                                    return (

                                        <div className={classes.stepperRoot}>

                                            <Stepper className={'px-0 py-0'} connector={
                                                <span className={'connector'}>
                                        <span className="flaticon2-right-arrow"></span>
                                    </span>
                                            } activeStep={currentStep} alternativeLabel>
                                                {['Description de la demande', 'Localisation', 'Période', 'Contacts'].map((label, index) => (
                                                    <Step className={index === currentStep ? 'active' : 'inactive'}
                                                          key={label}>
                                                        <StepLabel
                                                            StepIconComponent={NewFicheFormStepIcon}>{label}</StepLabel>
                                                    </Step>
                                                ))}
                                            </Stepper>

                                            <div className={'my-4'}>
                                                <Divider/>
                                            </div>

                                            <div className={'small my-3'}>
                                                Les champs avec un <span
                                                className="font-weight-bold text-danger">(*)</span> sont des champs
                                                obligatoires
                                            </div>


                                            {
                                                currentStep === 0 && (

                                                    <>
                                                        <div className="row">
                                                            <div
                                                                className={'col-12 h4 my-1 font-weight-bold text-primary'}>

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'type_travaux'}
                                                                    component={TextField}
                                                                    label={'Type de la demande'}
                                                                    variant="outlined"
                                                                    required={true}
                                                                    fullWidth={true}
                                                                    onChange={(e) => {

                                                                        formikHelpers.handleChange(e)

                                                                        formikHelpers.setFieldValue('nature_travaux', [])

                                                                    }}
                                                                    select
                                                                >

                                                                    <MenuItem value={1}>Electricité </MenuItem>
                                                                    <MenuItem value={2}>Eau
                                                                        potable</MenuItem>
                                                                    <MenuItem value={3}>Electricité et Eau
                                                                        potable</MenuItem>

                                                                </Field>

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'nature_travaux'}
                                                                    component={TextField}
                                                                    label={'Objet de la demande'}
                                                                    required={true}

                                                                    variant="outlined"
                                                                    fullWidth={true}
                                                                    select
                                                                    SelectProps={{
                                                                        multiple: true,
                                                                        renderValue: (selected) => {
                                                                            return selected.map(selectedItem => getItemById(([...groupedNature[formikHelpers.values.type_travaux], {
                                                                                id: -1,
                                                                                libelle: 'Autre CIE'
                                                                            }, {
                                                                                id: -2,
                                                                                libelle: 'Autre SODECI'
                                                                            },] || []), selectedItem)?.libelle).join(', ')
                                                                        }
                                                                    }}
                                                                >

                                                                    {
                                                                        (groupedNature[formikHelpers.values.type_travaux] || []).map(
                                                                            (item, index) => {


                                                                                return (
                                                                                    <MenuItem key={index}
                                                                                              value={item.id}>

                                                                                        <Checkbox
                                                                                            checked={formikHelpers.values.nature_travaux.filter(
                                                                                                nature => {
                                                                                                    return nature == item.id
                                                                                                }
                                                                                            ).length > 0}/>

                                                                                        {item.libelle}</MenuItem>
                                                                                )
                                                                            }
                                                                        )
                                                                    }

                                                                    {
                                                                        formikHelpers.values.type_travaux === 1 && (
                                                                            <MenuItem value={-1}>

                                                                                <Checkbox
                                                                                    checked={formikHelpers.values.nature_travaux.filter(
                                                                                        nature => {
                                                                                            return nature == -1
                                                                                        }
                                                                                    ).length > 0}/>
                                                                                AUTRES</MenuItem>
                                                                        )
                                                                    }

                                                                    {
                                                                        formikHelpers.values.type_travaux === 2 && (
                                                                            <MenuItem value={-2}>

                                                                                <Checkbox
                                                                                    checked={formikHelpers.values.nature_travaux.filter(
                                                                                        nature => {
                                                                                            return nature == -2
                                                                                        }
                                                                                    ).length > 0}/>
                                                                                AUTRES</MenuItem>
                                                                        )
                                                                    }

                                                                    {
                                                                        formikHelpers.values.type_travaux === 3 && (

                                                                            <MenuItem key={-1} value={-1}>

                                                                                <Checkbox
                                                                                    checked={formikHelpers.values.nature_travaux.filter(
                                                                                        nature => {
                                                                                            return nature == -1
                                                                                        }
                                                                                    ).length > 0}/>

                                                                                AUTRES CIE
                                                                            </MenuItem>

                                                                        )
                                                                    }


                                                                    {
                                                                        formikHelpers.values.type_travaux === 3 && (

                                                                            <MenuItem key={-2} value={-2}>

                                                                                <Checkbox
                                                                                    checked={formikHelpers.values.nature_travaux.filter(
                                                                                        nature => {
                                                                                            return nature == -2
                                                                                        }
                                                                                    ).length > 0}/>
                                                                                AUTRES SODECI
                                                                            </MenuItem>

                                                                        )
                                                                    }


                                                                </Field>

                                                            </div>

                                                            {

                                                                (formikHelpers.values.nature_travaux.includes(-1) || (formikHelpers.values.nature_travaux.includes(-1) && formikHelpers.values.type_travaux === 1)) && (

                                                                    <div className={'col-12 col-lg-6 my-3'}>

                                                                        <Field

                                                                            name={'autre_cie'}
                                                                            label={'(AUTRES CIE) precisez l\'objet de la demande'}
                                                                            component={TextField}
                                                                            variant="outlined"
                                                                            fullWidth={true}

                                                                        />

                                                                    </div>

                                                                )

                                                            }

                                                            {

                                                                (formikHelpers.values.nature_travaux.includes(-2) || (formikHelpers.values.nature_travaux.includes(-2) && formikHelpers.values.type_travaux === 2)) && (

                                                                    <div className={'col-12 col-lg-6 my-3'}>

                                                                        <Field

                                                                            name={'autre_sodecie'}
                                                                            label={'(AUTRES SODECI) precisez l\'objet de la demande'}
                                                                            component={TextField}
                                                                            variant="outlined"
                                                                            fullWidth={true}

                                                                        />

                                                                    </div>

                                                                )

                                                            }


                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'description_travaux'}
                                                                    label={'Description des travaux'}
                                                                    component={TextField}
                                                                    required={true}
                                                                    variant="outlined"
                                                                    fullWidth={true}

                                                                />

                                                            </div>


                                                            {
                                                                (formikHelpers.values.type_travaux === 1 || formikHelpers.values.type_travaux === 3) && (

                                                                    <div className={'col-12 col-lg-6 my-3'}>

                                                                        <Field

                                                                            name={'technique_travaux'}
                                                                            component={TextField}
                                                                            label={'Technique de travaux'}
                                                                            variant="outlined"
                                                                            required={true}
                                                                            fullWidth={true}
                                                                            onChange={(e) => {

                                                                                formikHelpers.handleChange(e)

                                                                                let hauteurs = formikHelpers.values.hauteurs;

                                                                                if (!e.target.value.includes('Démolition, Construction')) {

                                                                                    let {demolition, ...newHauteurs} = hauteurs;
                                                                                    hauteurs = newHauteurs;

                                                                                } else
                                                                                    hauteurs.demolition = ''

                                                                                if (!e.target.value.includes('Terrassement')) {

                                                                                    let {deblai, remblai, ...newHauteurs} = hauteurs;
                                                                                    formikHelpers.setFieldValue('technique_terrassement_type', []);
                                                                                    hauteurs = newHauteurs;

                                                                                } else {
                                                                                    hauteurs.remblai = ''
                                                                                    hauteurs.deblai = ''
                                                                                }

                                                                                formikHelpers.setFieldValue('hauteurs', hauteurs);

                                                                            }}
                                                                            select
                                                                            SelectProps={{
                                                                                multiple: true,
                                                                                renderValue: (selected) => {
                                                                                    return selected.join(', ')
                                                                                }
                                                                            }}
                                                                        >

                                                                            {
                                                                                techniquesTravaux.map(
                                                                                    technique => {
                                                                                        return (
                                                                                            <MenuItem key={technique.id}
                                                                                                      value={technique.libelle}>
                                                                                                <Checkbox
                                                                                                    checked={formikHelpers.values.technique_travaux.filter(
                                                                                                        nature => {
                                                                                                            return nature == technique.libelle
                                                                                                        }
                                                                                                    ).length > 0}/>{technique.libelle}
                                                                                            </MenuItem>
                                                                                        )
                                                                                    }
                                                                                )
                                                                            }

                                                                        </Field>

                                                                    </div>

                                                                )
                                                            }


                                                            {
                                                                formikHelpers.values.technique_travaux.includes('Terrassement') && (
                                                                    <div className={'col-12 col-lg-6 my-3'}>

                                                                        <Field

                                                                            name={'technique_terrassement_type'}
                                                                            component={TextField}
                                                                            label={'Type de terrassement'}
                                                                            required={true}
                                                                            variant="outlined"
                                                                            fullWidth={true}
                                                                            select
                                                                            onChange={(e) => {

                                                                                formikHelpers.handleChange(e)

                                                                                let hauteurs = formikHelpers.values.hauteurs;

                                                                                if (!e.target.value.includes('Remblai')) {

                                                                                    let {remblai, ...newHauteurs} = hauteurs;
                                                                                    hauteurs = newHauteurs;

                                                                                } else
                                                                                    hauteurs.remblai = ''

                                                                                if (!e.target.value.includes('Déblai')) {

                                                                                    let {deblai, ...newHauteurs} = hauteurs;
                                                                                    hauteurs = newHauteurs;

                                                                                } else
                                                                                    hauteurs.deblai = ''

                                                                                formikHelpers.setFieldValue('hauteurs', hauteurs);

                                                                            }}

                                                                            SelectProps={{
                                                                                multiple: true,
                                                                                renderValue: (selected) => {
                                                                                    return selected.join(', ')
                                                                                }
                                                                            }}
                                                                        >

                                                                            <MenuItem
                                                                                value={'Remblai'}>
                                                                                <Checkbox
                                                                                    checked={formikHelpers.values.technique_terrassement_type.filter(
                                                                                        nature => {
                                                                                            return nature == 'Remblai'
                                                                                        }
                                                                                    ).length > 0}/>Remblai</MenuItem>
                                                                            <MenuItem value={'Déblai'}>
                                                                                <Checkbox
                                                                                    checked={formikHelpers.values.technique_terrassement_type.filter(
                                                                                        nature => {
                                                                                            return nature == 'Déblai'
                                                                                        }
                                                                                    ).length > 0}/>Déblai</MenuItem>

                                                                        </Field>

                                                                    </div>
                                                                )
                                                            }

                                                            {
                                                                (
                                                                    (formikHelpers.values.technique_travaux.length > 0 && !formikHelpers.values.technique_travaux.includes('Terrassement'))
                                                                    ||
                                                                    (formikHelpers.values.technique_travaux.includes('Terrassement') && formikHelpers.values.technique_terrassement_type.length > 0)
                                                                )
                                                                && (
                                                                    <>


                                                                        {
                                                                            formikHelpers.values.technique_travaux.includes('Terrassement') &&
                                                                            formikHelpers.values.technique_terrassement_type.includes('Remblai') && (

                                                                                <div className="col-lg-6 col-12">

                                                                                    <Field

                                                                                        name={'hauteurs.remblai'}
                                                                                        component={TextField}
                                                                                        label={'Hauteur | Profondeur Remblai (en mètres)'}
                                                                                        required={true}
                                                                                        type={'number'}
                                                                                        variant="outlined"
                                                                                        fullWidth={true}
                                                                                    >
                                                                                    </Field>

                                                                                </div>

                                                                            )
                                                                        }


                                                                        {
                                                                            formikHelpers.values.technique_travaux.includes('Terrassement') &&
                                                                            formikHelpers.values.technique_terrassement_type.includes('Déblai') && (

                                                                                <div className="col-lg-6 col-12">

                                                                                    <Field
                                                                                        name={'hauteurs.deblai'}
                                                                                        component={TextField}
                                                                                        label={'Hauteur | Profondeur Déblai (en mètres)'}
                                                                                        required={true}
                                                                                        type={'number'}
                                                                                        variant="outlined"
                                                                                        fullWidth={true}
                                                                                    >
                                                                                    </Field>

                                                                                </div>

                                                                            )
                                                                        }


                                                                        {
                                                                            formikHelpers.values.technique_travaux.includes('Démolition, Construction') && (

                                                                                <div className="col-lg-6 col-12">

                                                                                    <Field
                                                                                        name={'hauteurs.demolition'}
                                                                                        component={TextField}
                                                                                        label={'Hauteur | Profondeur Démolition (en mètres)'}
                                                                                        required={true}
                                                                                        type={'number'}
                                                                                        variant="outlined"
                                                                                        fullWidth={true}
                                                                                    >
                                                                                    </Field>

                                                                                </div>

                                                                            )
                                                                        }


                                                                    </>
                                                                )
                                                            }

                                                            {
                                                                (formikHelpers.values.type_travaux === 1 || formikHelpers.values.type_travaux === 3) && (
                                                                    <div className={'col-12 col-lg-6 my-3'}>

                                                                        <Field

                                                                            name={'moyen_utilise_travaux'}
                                                                            component={TextField}
                                                                            label={'Moyens utilisés'}
                                                                            required={true}

                                                                            variant="outlined"
                                                                            fullWidth={true}
                                                                            select
                                                                            SelectProps={{
                                                                                multiple: true,
                                                                                renderValue: (selected) => {
                                                                                    return selected.map(selectedItem => getItemById([...moyensUtilise, {
                                                                                        id: -1,
                                                                                        libelle: 'AUTRES'
                                                                                    }], selectedItem)?.libelle).join(', ')
                                                                                }
                                                                            }}
                                                                        >

                                                                            {
                                                                                moyensUtilise.map(
                                                                                    moyen => {
                                                                                        return (
                                                                                            <MenuItem value={moyen.id}>

                                                                                                <Checkbox
                                                                                                    checked={formikHelpers.values.moyen_utilise_travaux.filter(
                                                                                                        item => {
                                                                                                            return item == moyen.id
                                                                                                        }
                                                                                                    ).length > 0}/>

                                                                                                {moyen.libelle}
                                                                                            </MenuItem>
                                                                                        )
                                                                                    }
                                                                                )
                                                                            }
                                                                            <MenuItem value={-1}>

                                                                                <Checkbox
                                                                                    checked={formikHelpers.values.moyen_utilise_travaux.filter(
                                                                                        item => {
                                                                                            return item == -1
                                                                                        }
                                                                                    ).length > 0}/>
                                                                                AUTRES</MenuItem>

                                                                        </Field>

                                                                    </div>
                                                                )
                                                            }


                                                            {

                                                                (formikHelpers.values.moyen_utilise_travaux.includes(-1)) && (

                                                                    <div className={'col-12 col-lg-6 my-3'}>

                                                                        <Field

                                                                            name={'moyen_utilise_travaux_autre'}
                                                                            label={'AUTRES moyens utilisés pour les travaux'}
                                                                            required={true}

                                                                            component={TextField}
                                                                            variant="outlined"
                                                                            fullWidth={true}

                                                                        />

                                                                    </div>

                                                                )

                                                            }


                                                        </div>

                                                        <div className={'row'}>

                                                            <div className={'col-12 col-lg-12 my-3'}>

                                                                <div>

                                                                    <div className={'d-inline-block'}>
                                                                        <span className="font-weight-bolder">
                                                                            Plan(s) d'implantation <span
                                                                            className="font-weight-bolder text-danger">&nbsp;&nbsp;(*)</span>

                                                                    <Button class={'btn btn-secondary ml-2'}
                                                                            onClick={() => {

                                                                                const files = formikHelpers.values.plan_implentation_travaux;

                                                                                if (files.length == 3) {


                                                                                    toast.error('Vous ne pouvez pas ajouter plus de 3 fichiers', {
                                                                                        position: "bottom-right",
                                                                                        autoClose: 5000,
                                                                                        hideProgressBar: false,
                                                                                        closeOnClick: true,
                                                                                        pauseOnHover: true,
                                                                                        draggable: true,
                                                                                        progress: undefined,
                                                                                    });

                                                                                    return;
                                                                                }

                                                                                formikHelpers.setFieldValue('plan_implentation_travaux', [
                                                                                    ...files,
                                                                                    {
                                                                                        value: undefined
                                                                                    }
                                                                                ])
                                                                            }}>Ajouter</Button>

                                                                        </span>

                                                                        <div className={'small'}>
                                                                            Cliquer sur le bouton "ajouter" pour
                                                                            ajouter <span className="text-danger">vos plans d’implantation</span> (3
                                                                            au maximum)
                                                                        </div>


                                                                        {
                                                                            formikHelpers.errors.plan_implentation_travaux && !Array.isArray(formikHelpers.errors.plan_implentation_travaux) && (
                                                                                <div
                                                                                    className="small font-weight-bolder text-danger">
                                                                                    {formikHelpers.errors.plan_implentation_travaux}
                                                                                </div>
                                                                            )
                                                                        }

                                                                    </div>


                                                                </div>

                                                                <div className={'row'}>

                                                                    <FieldArray name={'plan_implentation_travaux'}
                                                                                render={(arrayHelpers) => {
                                                                                    return formikHelpers.values.plan_implentation_travaux.map(
                                                                                        (item, index) => (
                                                                                            <div key={index}
                                                                                                 className={'col-md-4 col-12'}>

                                                                                                <Field

                                                                                                    name={`plan_implentation_travaux.${index}.value`}
                                                                                                    component={FileInput}
                                                                                                    variant="outlined"
                                                                                                    fullWidth={true}

                                                                                                />

                                                                                                <div
                                                                                                    className={'btn d-inline-block btn-light-danger ml-2 btn-icons'}
                                                                                                    onClick={() => {
                                                                                                        arrayHelpers.remove(index)
                                                                                                    }}>
                                                                                                    <span
                                                                                                        className={'flaticon2-delete'}></span>
                                                                                                </div>

                                                                                            </div>
                                                                                        )
                                                                                    )
                                                                                }}
                                                                    />

                                                                </div>

                                                                <div className={'mt-5'}>

                                                                    <div className={'small'}>
                                                                        Ou ajouter un lien de téléchargement pour les
                                                                        fichiers volumineux
                                                                    </div>

                                                                    <div>

                                                                        <div className={'d-flex align-items-center'}>
                                                                            <div
                                                                                className={'font-weight-bold mr-3'}>https
                                                                            </div>

                                                                            <Field

                                                                                name={'implantation_travaux_files_link'}
                                                                                component={TextField}
                                                                                noLabel={true}
                                                                                placeholder={''}
                                                                                variant="outlined"
                                                                                fullWidth={true}
                                                                                rootClassName={'flex-grow-1'}

                                                                            />

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>


                                                            <div className="col-12">


                                                            </div>


                                                        </div>

                                                    </>


                                                )
                                            }

                                            {
                                                currentStep === 1 && (

                                                    <>
                                                        <div className="row">

                                                            {
                                                                [1, 3].includes(formikHelpers.values.type_travaux) && (
                                                                    <div className={'col my-3'}>

                                                                        <Field

                                                                            name={'adresse_equipement_cie_proche'}
                                                                            component={TextField}
                                                                            label={'Adresse equipement CIE le plus proche'}
                                                                            variant="outlined"
                                                                            fullWidth={true}

                                                                        />

                                                                    </div>
                                                                )
                                                            }

                                                            {
                                                                [2, 3].includes(formikHelpers.values.type_travaux) && (
                                                                    <div className={'col my-3'}>

                                                                        <Field

                                                                            name={'adresse_equipement_sodeci_proche'}
                                                                            component={TextField}
                                                                            label={'Adresse equipement SODECI le plus proche'}
                                                                            variant="outlined"
                                                                            fullWidth={true}

                                                                        />

                                                                    </div>
                                                                )
                                                            }

                                                            <div className={'col-12 col-lg-12 my-3'}>

                                                                <div>

                                                                    <div className={'d-inline-block'}>
                                                                        <span className="font-weight-bolder">
                                                                            Plans d'ouvrage <span
                                                                            className="text-danger">(*)</span>

                                                                    <Button class={'btn btn-secondary ml-2'}
                                                                            onClick={() => {


                                                                                if (formikHelpers.values.fichiers_numerique_ouvrage && formikHelpers.values.fichiers_numerique_ouvrage.length < 3) {
                                                                                    formikHelpers.setFieldValue('fichiers_numerique_ouvrage', [
                                                                                        ...formikHelpers.values.fichiers_numerique_ouvrage,
                                                                                        {
                                                                                            value: undefined
                                                                                        }
                                                                                    ])
                                                                                } else {

                                                                                    toast.error('Vous ne pouvez pas ajouter plus de 3 fichiers', {
                                                                                        position: "top-right",
                                                                                        autoClose: 5000,
                                                                                        closeOnClick: true,
                                                                                        pauseOnHover: true,
                                                                                    });

                                                                                }
                                                                            }}>Ajouter</Button>
                                                                        </span>

                                                                        <div className={'small'}>
                                                                            Cliquer sur le bouton "ajouter" pour
                                                                            ajouter <span className="text-danger">vos plans d’ouvrage</span>
                                                                        </div>


                                                                        {
                                                                            formikHelpers.errors.fichiers_numerique_ouvrage && !Array.isArray(formikHelpers.errors.fichiers_numerique_ouvrage) && (
                                                                                <div
                                                                                    className="small font-weight-bolder text-danger">
                                                                                    {formikHelpers.errors.fichiers_numerique_ouvrage}
                                                                                </div>
                                                                            )
                                                                        }

                                                                    </div>


                                                                </div>

                                                                <div className={'row'}>

                                                                    <FieldArray name={'fichiers_numerique_ouvrage'}
                                                                                render={(arrayHelpers) => {
                                                                                    return formikHelpers.values.fichiers_numerique_ouvrage.map(
                                                                                        (item, index) => (
                                                                                            <div key={index}
                                                                                                 className={'col-md-4 col-12'}>

                                                                                                <Field

                                                                                                    name={`fichiers_numerique_ouvrage.${index}.value`}
                                                                                                    component={FileInput}
                                                                                                    variant="outlined"
                                                                                                    fullWidth={true}

                                                                                                />

                                                                                                <div
                                                                                                    className={'btn d-inline-block btn-light-danger ml-2 btn-icons'}
                                                                                                    onClick={() => {
                                                                                                        arrayHelpers.remove(index)
                                                                                                    }}>
                                                                                                    <span
                                                                                                        className={'flaticon2-delete'}></span>

                                                                                                </div>

                                                                                            </div>
                                                                                        )
                                                                                    )
                                                                                }}
                                                                    />

                                                                </div>

                                                                <div className={'my-5'}>

                                                                    <div className={'small'}>
                                                                        Ou ajouter un lien de téléchargement pour les
                                                                        fichiers volumineux
                                                                    </div>

                                                                    <div>

                                                                        <div className={'d-flex align-items-center'}>
                                                                            <div
                                                                                className={'font-weight-bold mr-3'}>https
                                                                            </div>

                                                                            <Field

                                                                                name={'ouvrages_numeriques_files_link'}
                                                                                component={TextField}
                                                                                noLabel={true}
                                                                                placeholder={''}
                                                                                variant="outlined"
                                                                                fullWidth={true}
                                                                                rootClassName={'flex-grow-1'}

                                                                            />

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>


                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'adresse_geo_chantier'}
                                                                    component={TextField}
                                                                    label={'Adresse'}
                                                                    variant="outlined"
                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <div className={'font-weight-bolder'}>
                                                                    Zone des travaux
                                                                </div>

                                                                <Field

                                                                    name={'zone_travaux_file.value'}
                                                                    component={FileInput}
                                                                    label={'Sélectionner un fichier indiquant la zone des travaux sur une carte'}
                                                                    variant="outlined"
                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                            <div className="col-12">

                                                                <div className={'mt-5'}>

                                                                    <div className={'small'}>
                                                                        Ou ajouter un lien de téléchargement pour les
                                                                        fichiers volumineux (Zone des travaux)
                                                                    </div>

                                                                    <div>

                                                                        <div className={'d-flex align-items-center'}>
                                                                            <div
                                                                                className={'font-weight-bold mr-3'}>https
                                                                            </div>

                                                                            <Field

                                                                                name={'zone_travaux_file_link'}
                                                                                component={TextField}
                                                                                noLabel={true}
                                                                                placeholder={''}
                                                                                variant="outlined"
                                                                                fullWidth={true}
                                                                                rootClassName={'flex-grow-1'}

                                                                            />

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div className={'col-6 my-3'}>

                                                                <Field

                                                                    name={'ville_id'}
                                                                    component={FormikGeoAutocomplete}
                                                                    label={'Ville'}
                                                                    required={true}
                                                                    multiple
                                                                    type={'villes'}
                                                                    fullWidth={true}
                                                                    variant="outlined"
                                                                    // select
                                                                    // SelectProps={{
                                                                    //     multiple: true,
                                                                    //     renderValue: (selected) => {
                                                                    //         return selected.map(selectedItem => getItemById(villes, selectedItem)?.libelle).join(', ')
                                                                    //     }
                                                                    // }}
                                                                    onChange={(villes) => {

                                                                        setSelectedVilles(villes);

                                                                        formikHelpers.setFieldValue('commune_id', [])
                                                                        formikHelpers.setFieldValue('quartier_id', [])

                                                                    }}

                                                                />

                                                            </div>

                                                            {
                                                                (

                                                                    <div className={'col-6 my-3'}>

                                                                        <Field

                                                                            name={'commune_id'}
                                                                            component={FormikGeoAutocomplete}
                                                                            disabled={!((childCommunes && childCommunes.length > 0))}
                                                                            label={'Commune'}
                                                                            type={'communes'}
                                                                            filters={filters}
                                                                            variant="outlined"
                                                                            fullWidth={true}
                                                                            variant="outlined"
                                                                            select
                                                                            SelectProps={{
                                                                                multiple: true,
                                                                                renderValue: (selected) => {
                                                                                    return selected.map(selectedItem => getItemById(childCommunes, selectedItem)?.libelle).join(', ')
                                                                                }
                                                                            }}
                                                                            onChange={(communes) => {

                                                                                setSelectedCommunes(communes);
                                                                                formikHelpers.setFieldValue('quartier_id', [])

                                                                            }}

                                                                        />


                                                                        {
                                                                            !(childCommunes && childCommunes.length > 0) && (

                                                                                <div className="small text-muted">
                                                                                    Aucune commune pour les villes
                                                                                    sélectionnées
                                                                                </div>

                                                                            )
                                                                        }

                                                                    </div>

                                                                )
                                                            }

                                                            <div className={'col-12 my-3'}>

                                                                {
                                                                    (

                                                                        <Field

                                                                            name={'quartier_id'}
                                                                            component={FormikGeoAutocomplete}
                                                                            type={'quartiers'}
                                                                            disabled={!(childQuartiers && childQuartiers.length > 0)}
                                                                            filters={filters}
                                                                            label={'Quartier'}
                                                                            variant="outlined"
                                                                            fullWidth={true}
                                                                            select
                                                                            SelectProps={{
                                                                                multiple: true,
                                                                                renderValue: (selected) => {
                                                                                    return selected.map(selectedItem => getItemById(childQuartiers, selectedItem)?.libelle).join(', ')
                                                                                }
                                                                            }}
                                                                            onChange={(value) => {
                                                                                setSelectedQuartier(value)
                                                                            }}

                                                                        />

                                                                    )
                                                                }

                                                                {
                                                                    !(childQuartiers && childQuartiers.length > 0) && (

                                                                        <div className="small text-muted">
                                                                            Aucun quartier pour les communes
                                                                            sélectionnées
                                                                        </div>

                                                                    )
                                                                }
                                                            </div>

                                                            {/*<div className={'col-6 my-3'}>*/}

                                                            {/*    {*/}
                                                            {/*        (*/}

                                                            {/*            <Field*/}

                                                            {/*                name={'rue'}*/}
                                                            {/*                component={TextField}*/}
                                                            {/*                // disabled={!(childRues && childRues.length > 0)}*/}
                                                            {/*                label={'Rue'}*/}
                                                            {/*                variant="outlined"*/}
                                                            {/*                fullWidth={true}*/}
                                                            {/*                onChange={(event) => {*/}
                                                            {/*                    formikHelpers.handleChange(event);*/}
                                                            {/*                }}*/}

                                                            {/*            >*/}
                                                            {/*            </Field>*/}

                                                            {/*        )*/}
                                                            {/*    }*/}

                                                            {/*</div>*/}


                                                            <div className={'col-12 my-3'}>

                                                                <Field

                                                                    name={'description_localisation'}
                                                                    label={'Description de la localisation'}
                                                                    required={true}

                                                                    component={TextField}
                                                                    variant="outlined"
                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                        </div>

                                                        <div className={'row'}>

                                                            <div className="col-12">
                                                                <span className="font-weight-bold h4">Position géographique</span>

                                                                <span onClick={() => {
                                                                    formikHelpers.setFieldValue('lat_lng',[
                                                                        ...formikHelpers.values.lat_lng,
                                                                        {
                                                                            key: generateRandomString(5)
                                                                        }
                                                                    ]);
                                                                }} className={'btn btn-light-success ml-4 btn-sm'}>
                                                                    <i className={'la la-plus'}></i>
                                                                    <span className={'d-inline-block mr-2 font-weight-bolder'}>AJOUTER</span>
                                                                </span>
                                                            </div>

                                                            <FieldArray name={'lat_lng'}
                                                                        render={(arrayHelpers) => {
                                                                            return formikHelpers.values.lat_lng.map(
                                                                                (item, index) => (
                                                                                    <div key={index}
                                                                                         className={'col-12 row'}>

                                                                                        <div className="col">

                                                                                            <Field

                                                                                                name={`lat_lng.${index}.lat`}
                                                                                                label={'Latitude'}
                                                                                                className={'col'}
                                                                                                type={'number'}
                                                                                                component={TextField}
                                                                                                variant="outlined"
                                                                                                fullWidth={true}

                                                                                            />

                                                                                        </div>

                                                                                        <div className="col">

                                                                                            <Field

                                                                                                name={`lat_lng.${index}.lng`}
                                                                                                type={'number'}
                                                                                                className={'col'}
                                                                                                label={'Longitude'}
                                                                                                component={TextField}
                                                                                                variant="outlined"
                                                                                                fullWidth={true}

                                                                                            />

                                                                                        </div>


                                                                                        <div
                                                                                            className={'btn align-self-end col-auto d-inline-block btn-light-danger ml-2 btn-icons'}
                                                                                            onClick={() => {
                                                                                                arrayHelpers.remove(index)
                                                                                            }}>
                                                                                                    <span
                                                                                                        className={'flaticon2-delete'}></span>

                                                                                        </div>

                                                                                    </div>
                                                                                )
                                                                            )
                                                                        }}
                                                            />


                                                        </div>

                                                        <div className={'row'}>

                                                            <div className={'col-12 my-3'}>

                                                                <Field

                                                                    name={'lat_lng'}
                                                                    component={GoogleMapsInput}
                                                                    variant="outlined"
                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                        </div>

                                                    </>

                                                )
                                                }


                                                {
                                                    currentStep === 2 && (
                                                        <>

                                                            <div className={'row'}>

                                                                {/*Adress*/}


                                                                <div className={'col-6 my-3'}>

                                                                    <Field
                                                                        min={'2021-01-25'}
                                                                        name={'date_debut_travaux'}
                                                                        className={classes.textField}
                                                                        label={'Date de début des travaux'}
                                                                        required={true}

                                                                        component={TextField}
                                                                        type={'date'}
                                                                        InputProps={{
                                                                            className: `${classes.textFieldInput}`
                                                                        }}
                                                                    />
                                                                </div>

                                                                <div className={'col-6 my-3'}>

                                                                    <Field
                                                                        name={'date_fin_travaux'}
                                                                        className={classes.textField}
                                                                        label={'Date de fin des travaux'}
                                                                        required={true}

                                                                        component={TextField}
                                                                        type={'date'}
                                                                        InputProps={{
                                                                            className: `${classes.textFieldInput}`
                                                                        }}
                                                                    />
                                                                </div>

                                                                <div className={'col-12 col-lg-12 my-3'}>

                                                                    <div>


                                                                        <div className={'d-inline-block'}>
                                                                            Fichiers de planning des travaux <span
                                                                            className="font-weight-bold text-danger">

                                                                    <Button class={'btn btn-secondary ml-2'}
                                                                            onClick={() => {

                                                                                if (formikHelpers.values.planning_travaux && formikHelpers.values.planning_travaux.length > 2) {

                                                                                    toast.error('Vous ne pouvez pas ajouter plus de 3 fichiers', {
                                                                                        position: "top-right",
                                                                                        autoClose: 5000,
                                                                                        closeOnClick: true,
                                                                                        pauseOnHover: true,
                                                                                    });

                                                                                    return;
                                                                                }


                                                                                formikHelpers.setFieldValue('planning_travaux', [
                                                                                    ...formikHelpers.values.planning_travaux,
                                                                                    {
                                                                                        value: undefined
                                                                                    }
                                                                                ])
                                                                            }}>Ajouter</Button>
                                                                    </span>

                                                                            <div className={'small'}>
                                                                                Cliquer sur le bouton "ajouter" pour
                                                                                ajouter <span className="text-danger">vos plannings des travaux</span>
                                                                            </div>


                                                                            {
                                                                                formikHelpers.errors.planning_travaux && !Array.isArray(formikHelpers.errors.planning_travaux) && (
                                                                                    <div
                                                                                        className="small font-weight-bolder text-danger">
                                                                                        {formikHelpers.errors.planning_travaux}
                                                                                    </div>
                                                                                )
                                                                            }

                                                                        </div>


                                                                    </div>

                                                                    <div className={'row'}>

                                                                        <FieldArray name={'planning_travaux'}
                                                                                    render={(arrayHelpers) => {
                                                                                        return formikHelpers.values.planning_travaux.map(
                                                                                            (item, index) => (
                                                                                                <div key={index}
                                                                                                     className={'col-md-4 col-12'}>

                                                                                                    <Field

                                                                                                        name={`planning_travaux.${index}.value`}
                                                                                                        component={FileInput}

                                                                                                        variant="outlined"
                                                                                                        fullWidth={true}

                                                                                                    />

                                                                                                    <div
                                                                                                        className={'btn d-inline-block btn-light-danger ml-2 btn-icons'}
                                                                                                        onClick={() => {
                                                                                                            arrayHelpers.remove(index)
                                                                                                        }}>
                                                                                                    <span
                                                                                                        className={'flaticon2-delete'}></span>

                                                                                                    </div>

                                                                                                </div>
                                                                                            )
                                                                                        )
                                                                                    }}
                                                                        />

                                                                    </div>

                                                                    <div className={'mt-5'}>

                                                                        <div className={'small'}>
                                                                            Ou ajouter un lien de téléchargement pour
                                                                            les
                                                                            fichiers volumineux
                                                                        </div>

                                                                        <div>

                                                                            <div
                                                                                className={'d-flex align-items-center'}>
                                                                                <div
                                                                                    className={'font-weight-bold mr-3'}>https
                                                                                </div>

                                                                                <Field

                                                                                    name={'planning_travaux_file_link'}
                                                                                    component={TextField}
                                                                                    noLabel={true}
                                                                                    placeholder={''}
                                                                                    variant="outlined"
                                                                                    fullWidth={true}
                                                                                    rootClassName={'flex-grow-1'}

                                                                                />

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>


                                                                <div className={'col-12 my-3'}>

                                                                    <Field
                                                                        name={'informations_supplementaire_periode'}
                                                                        className={classes.textField}
                                                                        label={'Informations supplémentaires'}
                                                                        component={TextField}
                                                                        InputProps={{
                                                                            className: `${classes.textFieldInput}`
                                                                        }}
                                                                    />
                                                                </div>


                                                            </div>


                                                        </>
                                                    )
                                                }


                                                {
                                                    currentStep === 3 && (
                                                        <div className={'row'}>


                                                            <div className={'col-12 my-1'}>

                                                                <Field
                                                                    name={'type_client_id'}
                                                                    component={TextField}
                                                                    label={'Type de client'}
                                                                    fullWidth={true}
                                                                    required={true}
                                                                    select
                                                                >

                                                                    {ficheTypes.filter(item => !!item.selectable).map(
                                                                        item => {
                                                                            return (
                                                                                <MenuItem value={item.id}
                                                                                          key={item.id}>{item.libelle}</MenuItem>
                                                                            )
                                                                        }
                                                                    )}

                                                                </Field>

                                                            </div>

                                                            {
                                                                formikHelpers.values.type_client_id == 1 && (
                                                                    <>

                                                                        <div className={'col-12 col-lg-6 my-3'}>

                                                                            <Field

                                                                                name={'nom'}
                                                                                component={TextField}
                                                                                label={'Nom'}
                                                                                required={true}

                                                                                fullWidth={true}

                                                                            />

                                                                        </div>

                                                                        <div className={'col-12 col-lg-6 my-3'}>

                                                                            <Field

                                                                                name={'prenoms'}
                                                                                component={TextField}
                                                                                label={'Prénom(s)'}
                                                                                required={true}

                                                                                fullWidth={true}

                                                                            />

                                                                        </div>
                                                                    </>
                                                                )
                                                            }


                                                            {
                                                                [2, 3].includes(formikHelpers.values.type_client_id) && (
                                                                    <>

                                                                        <div className={'col-12 col-lg-6 my-3'}>

                                                                            <Field

                                                                                name={'raison_sociale'}
                                                                                component={TextField}
                                                                                label={'Raison sociale'}
                                                                                required={true}

                                                                                fullWidth={true}

                                                                            />

                                                                        </div>

                                                                    </>
                                                                )
                                                            }


                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'mobile'}
                                                                    component={TextField}
                                                                    label={'Numéro de téléphone'}
                                                                    required={true}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment
                                                                            position="start">+225</InputAdornment>,
                                                                    }}
                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'mobile_2'}
                                                                    component={TextField}
                                                                    label={'Numéro de téléphone secondaire'}
                                                                    fullWidth={true}
                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment
                                                                            position="start">+225</InputAdornment>,
                                                                    }}
                                                                />

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'email'}
                                                                    component={TextField}
                                                                    label={'Email'}
                                                                    required={true}

                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'email_confirmation'}
                                                                    component={TextField}
                                                                    label={'Confirmation de l\'adresse email'}
                                                                    required={true}

                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'siege_sociale'}
                                                                    component={TextField}
                                                                    label={'Siège social de l\'entreprise'}
                                                                    fullWidth={true}

                                                                />

                                                            </div>


                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'nom_enterprise'}
                                                                    component={TextField}
                                                                    label={'Nom de l\'entreprise exécutant les travaux'}
                                                                    required={true}

                                                                    fullWidth={true}

                                                                />

                                                            </div>


                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'nom_sous_traitant'}
                                                                    component={TextField}
                                                                    label={'Nom de l\'entreprise sous traitante'}
                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'nom_prenoms_responsable_chantier'}
                                                                    component={TextField}
                                                                    label={'Nom du responsable de chantier'}
                                                                    fullWidth={true}

                                                                />

                                                            </div>

                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'contact_responsable_chantier'}
                                                                    component={TextField}
                                                                    label={'Numéro de téléphone du responsable de chantier'}

                                                                    InputProps={{
                                                                        startAdornment: <InputAdornment
                                                                            position="start">+225</InputAdornment>,
                                                                    }}
                                                                    fullWidth={true}

                                                                />

                                                            </div>
                                                            <div className={'col-12 col-lg-6 my-3'}>

                                                                <Field

                                                                    name={'fonction_responsable_chantier'}
                                                                    component={TextField}
                                                                    label={'Fonction du responsable de chantier'}
                                                                    fullWidth={true}

                                                                />

                                                            </div>
                                                            <div className={'col-12 col-lg-12 my-3'}>

                                                                <Field

                                                                    name={'informations_supplementaire'}
                                                                    component={TextField}
                                                                    label={'Informations supplémentaires'}
                                                                    fullWidth={true}

                                                                />

                                                            </div>


                                                        </div>
                                                    )
                                                }


                                                {
                                                    (

                                                        <div className={'row'}>

                                                            <div className="col-6">

                                                                {
                                                                    !!savedDatas && savedDatas.state && (
                                                                            <Button onClick={goToRecapitulatif} className={'btn btn-primary'}>Aller
                                                                                au
                                                                                récapitulatif</Button>
                                                                    )
                                                                }

                                                                {
                                                                    !savedDatas && (

                                                                        <ConfirmationModal onConfirm={
                                                                            () => {
                                                                                history.push('/')
                                                                            }
                                                                        } title={'Confirmation'}
                                                                                           text={'Êtes vous sûr de vouloir annuler le formulaire ? vos données seront perdues'}>
                                                                            <div className="btn btn-danger">
                                                                                Annuler
                                                                            </div>
                                                                        </ConfirmationModal>

                                                                    )
                                                                }

                                                                {
                                                                    currentStep !== 0 && (
                                                                        <BootstrapLoadingButton onClick={goToPrevStep}
                                                                                                className={'btn ml-1 btn-primary btn-light-primary'}>
                                                                        <span
                                                                            className="font-weight-bold">Precédent</span>
                                                                        </BootstrapLoadingButton>
                                                                    )

                                                                }

                                                            </div>


                                                            {
                                                                currentStep !== 3 && (
                                                                    <div className="col-6 text-right">
                                                                        <BootstrapLoadingButton
                                                                            isLoading={isStepSaving}
                                                                            onClick={goToNextStep}
                                                                            className={'btn btn-success'}>
                                                                        <span
                                                                            className="font-weight-bold">Suivant</span>
                                                                        </BootstrapLoadingButton>
                                                                    </div>
                                                                )

                                                            }

                                                            {currentStep === 3 && (

                                                                <div className="col-6 text-right">


                                                                    <BootstrapLoadingButton isLoading={isSubmitting}
                                                                                            onClick={goToNextStep}
                                                                                            className={'btn btn-success my-5 w-100 d-block'}>
                                                                        {
                                                                            !!queryFormCode ? 'MODIFIER MA DEMANDE' : 'ENREGISTRER MA DEMANDE'
                                                                        }
                                                                    </BootstrapLoadingButton>
                                                                </div>)

                                                            }


                                                        </div>

                                                    )
                                                }

                                                <div className={'text-right'}>

                                                </div>

                                                </div>

                                                )
                                            }
                                            }

                                        </Formik>
                                    )
                                }
                                </>

                                );
                            });

                            export default NewFicheForm;